const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
const OPEN_PASA_API_URL = process.env.REACT_APP_OPEN_PASA_API_URL;
const LOCALITY_API_URL = process.env.REACT_APP_LOCALITY_API_URL;



export const PASA_API = {
  DROP_USER: (custId) =>
    [BASE_API_URL, "v1", "journey", `drop?id=${custId}`].join("/"),
  TRACK_USER: (custId, _inception, isPayout) =>
    // [BASE_API_URL, "v1", "journey", `track?id=${custId}&inception=${_inception}`].join("/"),
    [BASE_API_URL, "v1", "journey"]
      .concat(
        `track?id=${custId}${_inception ? `&inception=${_inception}` : ""}${
          isPayout ? `&checkPayout=${isPayout}` : ""
        }`
      )
      .join("/"),
  GET_OFFER: (custId) =>
    [BASE_API_URL, "v1", "offer", `?id=${custId}`].join("/"),
  GET_CONFIGS: (custId) =>
    [BASE_API_URL, "v1", "config", `?id=${custId}`].join("/"),
  AGENT_CODE: (custId) => [BASE_API_URL, "v1", `agent?id=${custId}`].join("/"),
  AGENT_CODE_WITHOUT_ID: () => [BASE_API_URL, "v1", `agent/validate`].join("/"),
  JOURNEY_PROGRESS: (stage, custId) =>
    [BASE_API_URL, "v1", "journey", stage, `?id=${custId}`].join("/"),
  JOURNEY_SUBMIT: (custId, payoutjourney) => {
    let payoutParam = "";
    if (payoutjourney) {
      payoutParam += "&checkPayout=true";
    }
    return [
      BASE_API_URL,
      "v1",
      "journey",
      "submit",
      `?id=${custId}${payoutParam}`,
    ].join("/");
  },
  VALIDATE_PINCODE: () => [BASE_API_URL, "v1", "journey", `pincode`].join("/"),
  VALIDATE_ACCOUNT: () =>
    [BASE_API_URL, "v1", "journey", `account-validate`].join("/"),
  FETCH_BRANCH_MICR: () =>
    [BASE_API_URL, "v1", "journey", `getBankdetails`].join("/"),
  VALIDATE_PAN: () => [BASE_API_URL, "v1", "journey", `ckyc`].join("/"),
  ILLUSTRATION: (custId) =>
    [BASE_API_URL, "v1", `illustration?id=${custId}`].join("/"),
  OTP_JOURNEY_FETCH: [OPEN_PASA_API_URL, "v1", `offer`, `sendOtp`].join("/"),
  OTP_JOURNEY_VALIDATE: [OPEN_PASA_API_URL, "v1", `offer`, `validateOtp`].join(
    "/"
  ),
  FILE_UPLOAD: (custId) =>
    [BASE_API_URL, "v1", `document/uploadAddrProof?id=${custId}`].join("/"),
  SESSION_START: () =>
    [BASE_API_URL, "v1", "journey", "session-start"].join("/"),

  SESSION_END: () => [BASE_API_URL, "v1", "journey", "session-end"].join("/"),
  POST_PLANDETAILS_SUBMIT: (custId) =>
    [BASE_API_URL, "v1", "journey", `basic-details?id=${custId}`].join("/"),
  PREFILL_GENERATEOTP: [BASE_API_URL, "v1", "journey", "generate-otp"].join(
    "/"
  ),
  PREFILL_VALIDATE: [BASE_API_URL, "v1", "journey", "validate-otp"].join("/"),
  POST_PAYOUT: (custId) =>
    [BASE_API_URL, "v1", "journey", "payout-details", `?id=${custId}`].join("/"),
  GET_BANKDETAILS :() => [BASE_API_URL, "v1", "journey", "getBankdetails"].join("/"),
  SAVE_BANKDETAILS : () =>[BASE_API_URL, "v1", "journey", "saveBankdetails"].join("/"),
    CONSENT_GENERATE_OTP : (custId) =>
    [BASE_API_URL, "v1", "journey", "customer-generate-otp"].join("/"),
  CONSENT_VALIDATE_OTP : () =>
    [BASE_API_URL, "v1", "journey", "customer-validate-otp"].join("/"),
  
};

export const OPEN_PASA_API = {
  GET_OFFERS: [OPEN_PASA_API_URL, "v1", `open-market`, `offer`].join("/"),
  VALIDATE_OPEN_PINCODE: () => [OPEN_PASA_API_URL, "v1", "open-market", `pincode`].join("/"),
  VALIDATE_IOP : [OPEN_PASA_API_URL, "v1", `open-market`, `retail` , `insurance`, `ic`, `callback`].join("/"),
  GET_OFFERS_TEBT: (pan,userId) => [OPEN_PASA_API_URL, "v1", `open-market`, `offer`, `?pan=${pan}&userId=${userId}`].join("/"),
  START_JOURNEY: [OPEN_PASA_API_URL, "v1", `open-market`, `journey`].join("/"),
  FILE_UPLOAD: (custId) =>
    [OPEN_PASA_API_URL, "v1", `document?id=${custId}`].join("/"),
  SUITABILITY_MATRIX: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `questionnaire`
  ].join("/"),
  HBANK_OTP_GENERATE: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `generate-otp`
  ].join("/"),
CUSTOMER_OTP_GENERATE: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `customer-generate-otp`
  ].join("/"),
   CUSTOMER_OTP_VALIDATE: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `customer-validate-otp`
  ].join("/"),
  HBANK_OTP_VALIDATE: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `validate-otp`
  ].join("/"),
  HBANKEMP_OTP_GENERATE: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `sendOtp-hbank`
  ].join("/"),
  HBANKEMP_OTP_VALIDATE: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `validateOtp-hbank`
  ].join("/"),
  DEDUPE_LOGIN: [
    OPEN_PASA_API_URL,
    "v1",
    `open-market`,
    `dedupe-login`
  ].join("/"),
};
